module.exports = __webpack_public_path__ + "media/night/230-5692b7c7.svg";